export interface CustomerContactCharacteristic {
  CharacteristicType?: string;
  CharacteristicValue?: string;
}

export class CreateCustomerContact {
  public AccountNumber: string = '';
  public Email?: string = '';
  public ContactType?: string = '';
  public Comments?: string = '';
  public RequestSource?: string = '';
  public CustomerContactCharacteristic?: CustomerContactCharacteristic[] = [];
}
